import React from "react";
import outlineStar from "../assets/outline-star.png";
import filledStar from "../assets/filled-star.png";
const RatingComponent = ({ rating, setRating }) => {
  return (
    <ul className="my-1 flex list-none gap-1 p-0" data-te-rating-init>
      <li value={1} onClick={(e) => setRating(1)}>
        <img
          src={rating >= 1 ? filledStar : outlineStar}
          className="w-5 h-5"
          alt=""
        />
      </li>
      <li value={2} onClick={(e) => setRating(2)}>
        <img
          src={rating >= 2 ? filledStar : outlineStar}
          className="w-5 h-5"
          alt=""
        />
      </li>
      <li value={3} onClick={(e) => setRating(3)}>
        <img
          src={rating >= 3 ? filledStar : outlineStar}
          className="w-5 h-5"
          alt=""
        />
      </li>
      <li value={4} onClick={(e) => setRating(4)}>
        <img
          src={rating >= 4 ? filledStar : outlineStar}
          className="w-5 h-5"
          alt=""
        />
      </li>
      <li value={5} onClick={(e) => setRating(5)}>
        <img
          src={rating >= 5 ? filledStar : outlineStar}
          className="w-5 h-5"
          alt=""
        />
      </li>
    </ul>
  );
};

export default RatingComponent;
